/* globals WEBPACK_FF_HIDE_PROVISIONING_ERRORS */
import { setHideProvisioningErrors } from "@insightfulscience/activations/feature-flags";

setHideProvisioningErrors(WEBPACK_FF_HIDE_PROVISIONING_ERRORS);
